// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1xbAm","select":"Header_select__3KvAF","clinic":"Header_clinic__37mqY"};